import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";

export class KMDXHBlackBg extends PIXI.Container implements StageLayer {

    private _blackBg: PIXI.Graphics;
    private _flickerTl: gsap.core.Timeline | undefined;

    constructor() {
        super();
        this.name = "KMDXHBlackBg";

        this.init();
    }

    public show(alpha: number): void {
        this._blackBg.alpha = alpha;
        this._blackBg.visible = true;
    }

    public playFlicker(): void {
        if (this._flickerTl) {
            return;
        }
        this._flickerTl = undefined;

        const tl: gsap.core.Timeline = gsap.timeline({
            repeat: -1
        });

        tl.to(this._blackBg, {
            duration: 0.1,
            alpha: 0.64
        });
        tl.to(this._blackBg, {
            duration: 0.1333 - 0.1,
            alpha: 0
        });
        tl.to(this._blackBg, {
            duration: 0.2333 - 0.1333,
            alpha: 0.61
        });
        tl.to(this._blackBg, {
            duration: 0.3 - 0.2333,
            alpha: 0
        });

        tl.to(this._blackBg, {
            duration: 0.4667 - 0.3667,
            alpha: 0.64
        }, 0.3667);
        tl.to(this._blackBg, {
            duration: 0.5333 - 0.4667,
            alpha: 0
        });
        tl.to(this._blackBg, {
            duration: 0.6 - 0.5333,
            alpha: 0.61
        });
        tl.to(this._blackBg, {
            duration: 0.6667 - 0.6,
            alpha: 0
        });

        this._flickerTl = tl;
    }

    public stopFlicker(): void {
        if (this._flickerTl) {
            this._flickerTl.totalProgress(1);
            this._flickerTl.kill();
        }

        this._flickerTl = undefined;
    }

    public pump(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this._blackBg, {
            duration: duration,
            alpha: 0
        });
        tl.to(this._blackBg, {
            duration: duration,
            alpha: 0.4
        });

        return tl;
    }

    public hide(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (this._blackBg.alpha) {
            tl.to(this._blackBg, {
                duration: 3 / 30,
                alpha: 0
            });
        }
        tl.add(() => {
            this._blackBg.visible = false;
        });

        return tl;
    }

    private init(): void {
        this._blackBg = new PIXI.Graphics().beginFill(0x000000, 1).drawRect(-480, -480, 1680, 1680).endFill();
        this._blackBg.visible = false;
        this.addChild(this._blackBg);
    }
}